<h2>Encountered an error:</h2>
<p>{{ error }}</p>
<br />
<p>Let us know, and try again.</p>
